import f from "../../../../contract-lib/assets/abi/polygon-gnosissafe.json.js";
import d from "../../../../contract-lib/assets/abi/polygon-weth.json.js";
import h from "../../../../contract-lib/constants/address.js";
import { GNOSIS_SAFE_UPDATED_MAGIC_VALUE as m } from "../../../constants/login.js";
import { RETRY as w } from "../../../constants/retry.js";
import { WalletType as n } from "../../../constants/web3.js";
import l from "../../config/network-mainnet.json.js";
import s from "./Metamask.js";
import p from "./WalletConnect.js";
import { getProvider as g } from "../../../util/authenication/index.js";
import { convertUtf8ToHex as k } from "@walletconnect/utils";
import C from "p-retry";
const t = class t {
  static prepareTokenContract() {
    if (!t.tokenContract) {
      const e = h.WETH, r = d, a = new t.currentWeb3.eth.Contract(r, e);
      t.tokenContract = a;
    }
    return t.tokenContract;
  }
  static async getWETHBalance(e) {
    if (!t.currentWeb3 || !t.currentProvider)
      return console.warn("Skip get balance due to no web3 or provider"), 0;
    t.tokenContract || t.prepareTokenContract();
    const r = await t.tokenContract.methods.balanceOf(e).call();
    return Promise.resolve(parseFloat(t.currentWeb3.utils.fromWei(r)));
  }
  static async signRequest(e) {
    const r = await t.currentWeb3.eth.personal.sign(k(e), t.currentActiveAccount);
    if (t.isSmartContractWallet) {
      const a = new t.currentWeb3.eth.Contract(f, t.currentActiveAccount), c = t.currentWeb3.utils.keccak256(`Ethereum Signed Message:
${e.length}${e}`);
      await C(async () => {
        try {
          if (await a.methods.isValidSignature(c, "0x").call() !== m)
            throw new Error("Invalid signature");
        } catch {
          throw new Error("Invalid signature");
        }
      }, {
        ...w.WAIT_VERIFY_GNOSIS,
        onFailedAttempt: (o) => {
          (o.attemptNumber - 1) % 10 === 0 && console.info("waiting for Gnosis Safe to update signature");
        }
      });
    }
    return r;
  }
  static async requestLogout() {
    t.walletType === n.WalletConnect && t.currentProvider && t.currentProvider.disconnect && await t.currentProvider.disconnect();
  }
  static async getBalance(e) {
    return t.currentWeb3 ? await t.currentWeb3.eth.getBalance(e) : "";
  }
  // Check if the user is in the corrent network
  static async verifyNetwork() {
    if (!t.currentProvider || !t.currentWeb3) return !1;
    const e = l, r = t.currentWeb3.utils.hexToNumber(e.chainId);
    return await t.currentWeb3.eth.net.getId() === r;
  }
  static addCallback(e) {
    let r = !1;
    t.refreshCallback.forEach(function(a) {
      a.toString() === e.toString() && (r = !0);
    }), r || t.refreshCallback.push(e);
  }
  static async updateInfo() {
    for (let e = 0; e < t.refreshCallback.length; e++)
      try {
        await t.refreshCallback[e]();
      } catch (r) {
        console.error(r);
        break;
      }
  }
  static async getAccount() {
    return await t.currentProvider.request({
      method: "eth_accounts"
    });
  }
  static async switchPolygonNetwork() {
    let e = !1, r = !0;
    const a = l, c = {
      method: "wallet_switchEthereumChain",
      params: [{
        chainId: a.chainId
      }]
    }, o = {
      method: "wallet_addEthereumChain",
      params: [a]
    };
    return await t.currentProvider.request(c).then().catch((i) => {
      console.error(i), e = !0, r = !1;
    }), e && await t.currentProvider.request(o).then().catch((i) => {
      console.error(i);
    }), r = !0, r;
  }
  static async setDefaultProvider(e) {
    switch (t.walletType = g() || n.Metamask, t.walletType) {
      case n.Metamask:
        s.detectMetamask() && (await s.setDefaultProvider(e), await s.requestLogin());
        break;
      case n.WalletConnect:
        await p.requestLogin();
        break;
    }
  }
};
t.currentActiveAccount = "", t.refreshCallback = [], t.walletType = n.None, t.walletConnectId = "", t.isSmartContractWallet = !1;
let u = t;
export {
  u as default
};
//# sourceMappingURL=Web3Instance.js.map
